<template>
  <div>
    <v-dialog v-model="dialog" max-width="1024px">
      <v-card>
        <v-card-title class="mx-3 d-block" style="position: relative;">
          <div class="text-center">
            {{ $t('MaterialTemplate.priceTrendTitle') }}
          </div>
          <div class="mt-2">
            <span
              class="red--text d-inline-block text-truncate"
              style="max-width: 360px"
            >
              {{ currentDetail ? currentDetail.material_name : '' }}
            </span>
          </div>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                style="position: absolute; top: 14px; right: 14px;"
                @click="dialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-8 text-center subtitle-1">
          <div v-if="last_purchase_price !== null" class="text-left mx-3 mb-4" style="color: #26A69A;">
            {{ $t('MaterialTemplate.lastPurchasePrice') }}{{ $t('Global.colon') }}{{ $t('Global.money') }}{{ last_purchase_price | formatMoney}}
          </div>
          <div style="height: 45vh; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary"
              size="48"
            ></v-progress-circular>
            <div v-else-if="price_histories.length === 0" class="no-data-text">
              <p class="grey--text text--darken-1 mt-3 mb-0">{{ $t('MaterialTemplate.historyNoPrice') }}</p>
            </div>
            <div v-else id="chartLineBox" style="flex: 1; width: 100%; height: 100%;"></div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import i18n from "@/i18n";
import datetimeUtils from "@/plugins/datetimeUtils";
import MaterialTemplates from "@/api/material_templates";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts";

export default {
  name: "DialogTemplatePriceHistories",

  components: {
  },

  props: {
    value: Boolean,
    currentDetail: Object,
    templateId: Number,
  },

  data: () => ({
    dialog: false,
    loading: false,
    price_histories: [],
    last_purchase_price: null,
    lineChartData: [],
    monitorTime: "",
  }),
  methods: {
    drawLineChart() {
      this.chartLine = echarts.init(document.getElementById("chartLineBox"));

      // 指定图表的配置项和数据
      var self = this;
      var option = {
        tooltip: {
          //设置tip提示
          trigger: "axis",
          extraCssText: 'text-align: left;',
          formatter: function (params) {
            var res = '';
            params.forEach(function (item) {
              res += item.marker + ' ' + i18n.t("Global.money") + item.value;
              if (self.price_histories && self.price_histories[item.dataIndex]) {
                res += '<br/>' + i18n.t("MaterialTemplate.historyModifier") + self.price_histories[item.dataIndex].creater_name_value;
                res += '<br/>' + i18n.t("MaterialTemplate.historyOperationTime") + datetimeUtils.formatTime(self.price_histories[item.dataIndex].created);
              }
            });
            return res;
          },
        },

        // legend: {
        //设置区分（哪条线属于什么）
        // data: [],
        // },
        color: ["#26A69A"], //设置区分（每条线是什么颜色，和 legend 一一对应）
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            // restore: {},
            // saveAsImage: {}
          }
        },
        xAxis: {
          show: false,
          type: "category",
        },
        yAxis: {
          name: i18n.t("Quotations.DetailFields.yAxisName"),
          nameTextStyle: {
            color: "#26A69A",
            fontSize: 16,
            padding: [0, 0, 10, 0],
          },
          axisLine: {
            lineStyle: {
              color: "#26A69A",
            },
          },
          axisLabel: {
            formatter: function (value) {
              return i18n.t("Global.money") + value;
            },
          },
          type: "value",
        },
        series: [
          {
            name: '',
            symbolSize: 20,
            data: this.lineChartData,
            // data: [10,2,5,20],
            type: "line", // 类型为折线图
            label: {
              show: true,
              position: 'top',
              distance: 10,
              formatter: function (params) {
                return i18n.t("Global.money") + params.value;
              },
              color: '#fff',
              backgroundColor: '#009688',
              borderRadius: 4,
              padding: [4, 8],
              fontSize: 12,
            },
            markPoint: {
              label: {
                formatter: function (params) {
                  return i18n.t("Global.money") + params.value;
                },
              },
              data: []
            },
            markLine: {
              label: {
                formatter: function (params) {
                  return i18n.t("Global.money") + params.value;
                },
              },
              data: [{ type: 'average', name: 'Avg' }]
            },
            lineStyle: {
              color: "#26A69A",
            },
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog && this.currentDetail) {
          this.loading = true;
          this.price_histories = [];
          MaterialTemplates.getTemplatePriceHistories({material_id: this.currentDetail.material_id, template_id: this.templateId}).then(
            function (response) {
              this.loading = false;
              if (response.data.status.isOK()) {
                this.price_histories = response.data.price_histories;
                this.last_purchase_price = response.data.last_purchase_price;
              }
          }.bind(this)).catch(function () {
              this.loading = false;
          }.bind(this))

        }else {
          this.xAxisData = [];
          this.lineChartData = [];
          this.last_purchase_price = null;
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          // 弹窗关闭时销毁图表实例
          if (this.chartLine) {
            this.chartLine.dispose();
            this.chartLine = null;
          }
        }
        this.$emit("input", this.dialog);
      },
    },
    price_histories: {
      deep: true,
      handler() {
        if (this.price_histories && this.price_histories.length) {
          this.lineChartData = this.price_histories.map(item => item.value);

          if (this.lineChartData.length) {
            this.$nextTick(() => {
              this.drawLineChart();
            });
          }
        } else {
          // 无数据时清空图表数据并销毁已存在的图表实例
          this.lineChartData = [];
          if (this.chartLine) {
            this.chartLine.dispose();
            this.chartLine = null;
          }
        }
      },
    },
    // value: {
    //   immediate: true, //初始赋值也调用
    //   handler() {
    //     if (this.value) {
    //       this.dialog = true;
    //       //渲染折线图
    //       clearInterval(this.monitorTime);
    //       this.monitorTime = setTimeout(
    //               function () {
    //                 this.drawLineChart();
    //               }.bind(this),
    //               1
    //       );
    //     } else {
    //       this.xAxisData = [];
    //       this.lineChartData = [];
    //       echarts.dispose(document.getElementById("chartLineBox"))
    //       this.$emit("close", this.dialog);

    //     }
    //   },
    // },
  },
  beforeDestroy() {
    clearInterval(this.monitorTime);
    if (this.chartLine) {
      this.chartLine.dispose();
      this.chartLine = null;
    }
  },
};
</script>
